import React from "react"

import PosStatusHistory from 'pages/parts/PosStatusHistory'

function Index() {
	return <PosStatusHistory apiUrl="/partner/pos-status-history" />
}

export default Index
